import { useEffect, useRef } from 'react';

/**
 * Custom hook to use setInterval in a React-friendly way
 * @param {Function} callback - The function to call at each interval
 * @param {number|null} delay - The delay in milliseconds (null to pause)
 */
export default function useInterval(callback, delay) {
    const savedCallback = useRef();

    // Remember the latest callback
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // Set up the interval
    useEffect(() => {
        // Don't schedule if no delay is specified
        if (delay === null || delay === undefined) {
            return;
        }

        const tick = () => {
            if (savedCallback.current) {
                savedCallback.current();
            }
        };

        const id = setInterval(tick, delay);

        // Clean up on unmount or when delay changes
        return () => {
            clearInterval(id);
        };
    }, [delay]);
}
